const header = document.querySelector("[data-site-header]");
const triggers = [...header.querySelectorAll("[data-menu-trigger]")];
const panels = [...header.querySelectorAll("[data-menu-panel]")];
const mobileMenuToggle = header.querySelector("[data-mobile-menu-toggle]");
const mobileDrawer = header.querySelector("[data-mobile-drawer]");
const mobileScreens = [...header.querySelectorAll("[data-mobile-screen]")];
const mobileOpenButtons = [...header.querySelectorAll("[data-mobile-open]")];
const mobileBackButtons = [...header.querySelectorAll("[data-mobile-back]")];
const mobileCloseButtons = [...header.querySelectorAll("[data-mobile-close]")];
const storyTabs = [...header.querySelectorAll("[data-story-tab]")];
const storyPanels = [...header.querySelectorAll("[data-story-panel]")];
const mobileShopGroups = [...header.querySelectorAll(".mobile-accordion details")];
const searchToggles = [...header.querySelectorAll("[data-header-search-toggle]")];
const searchCloseButtons = [...header.querySelectorAll("[data-header-search-close]")];

let openMenu = null;
let pinnedMenu = null;
let mobileMenuOpen = false;
let searchOpen = false;

function updateScrolledState() {
  header.classList.toggle("is-scrolled", window.scrollY > 8);
}

function updateStickyOffset() {
  const offset = [...document.querySelectorAll("aside[class*='announcement'], .mobile-announcement")].reduce((total, announcement) => {
    const styles = window.getComputedStyle(announcement);
    if (styles.display === "none" || styles.visibility === "hidden") return total;
    return total + announcement.getBoundingClientRect().height;
  }, 0);

  header.style.top = `${Math.round(offset)}px`;
  header.style.setProperty("--mobile-announcement-height", `${Math.round(offset)}px`);
}

updateScrolledState();
updateStickyOffset();
window.addEventListener("scroll", updateScrolledState, { passive: true });
window.addEventListener("resize", updateStickyOffset);

function renderMenu(name) {
  openMenu = name;
  header.classList.toggle("has-open-menu", Boolean(name));

  triggers.forEach((trigger) => {
    const isOpen = trigger.dataset.menuTrigger === name;
    trigger.classList.toggle("is-active", isOpen);
    trigger.setAttribute("aria-expanded", String(isOpen));
  });

  panels.forEach((panel) => {
    panel.hidden = panel.dataset.menuPanel !== name;
  });
}

function closeMenu() {
  pinnedMenu = null;
  renderMenu(null);
}

function setSearch(open, source) {
  searchOpen = open;
  header.classList.toggle("is-search-open", open);

  searchToggles.forEach((toggle) => {
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Search open" : "Open search");
  });

  if (!open) return;

  closeMenu();
  if (mobileMenuOpen) setMobileMenu(false);

  const input = source?.closest("[data-header-search]")?.querySelector("[data-header-search-input]")
    || header.querySelector("[data-header-search-input]");
  requestAnimationFrame(() => input?.focus());
}

function showMobileScreen(name) {
  mobileScreens.forEach((screen) => {
    screen.hidden = screen.dataset.mobileScreen !== name;
  });
  mobileDrawer.scrollTop = 0;
}

/* The drawer hangs below the header, but how far down the screen that is
   depends on whether the announcement bar is still showing (always on the
   home page). Measure it, so the drawer ends exactly at the bottom of the
   visible screen and everything in it can be scrolled to. */
function fitMobileDrawer() {
  if (!mobileMenuOpen) return;
  const top = Math.max(0, Math.round(mobileDrawer.getBoundingClientRect().top));
  document.documentElement.style.setProperty("--ck-drawer-top", `${top}px`);
}

function setMobileMenu(open) {
  mobileMenuOpen = open;
  mobileDrawer.hidden = !open;
  header.classList.toggle("is-mobile-open", open);
  mobileMenuToggle.classList.toggle("is-open", open);
  mobileMenuToggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
  document.documentElement.classList.toggle("mobile-menu-open", open);
  document.body.classList.toggle("mobile-menu-open", open);

  if (open) {
    showMobileScreen("main");
    fitMobileDrawer();
  }
}

window.addEventListener("resize", fitMobileDrawer);
window.visualViewport?.addEventListener("resize", fitMobileDrawer);

function showStoryTab(name) {
  storyTabs.forEach((tab) => {
    tab.setAttribute("aria-selected", String(tab.dataset.storyTab === name));
  });

  storyPanels.forEach((panel) => {
    panel.hidden = panel.dataset.storyPanel !== name;
  });
}

triggers.forEach((trigger) => {
  const menuName = trigger.dataset.menuTrigger;

  trigger.addEventListener("mouseenter", () => {
    if (!pinnedMenu) renderMenu(menuName);
  });

  trigger.addEventListener("focus", () => {
    if (!pinnedMenu) renderMenu(menuName);
  });

  trigger.addEventListener("click", () => {
    if (pinnedMenu === menuName) {
      closeMenu();
      return;
    }

    pinnedMenu = menuName;
    renderMenu(menuName);
  });
});

header.addEventListener("mouseleave", () => {
  if (!pinnedMenu) renderMenu(null);
});

mobileMenuToggle.addEventListener("click", () => {
  if (searchOpen) setSearch(false);
  setMobileMenu(!mobileMenuOpen);
});

searchToggles.forEach((toggle) => {
  toggle.addEventListener("click", () => setSearch(true, toggle));
});

searchCloseButtons.forEach((button) => {
  button.addEventListener("click", () => setSearch(false));
});

mobileOpenButtons.forEach((button) => {
  button.addEventListener("click", () => {
    showMobileScreen(button.dataset.mobileOpen);
  });
});

mobileBackButtons.forEach((button) => {
  button.addEventListener("click", () => {
    showMobileScreen("main");
  });
});

mobileCloseButtons.forEach((button) => {
  button.addEventListener("click", () => {
    setMobileMenu(false);
  });
});

storyTabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    showStoryTab(tab.dataset.storyTab);
  });
});

mobileShopGroups.forEach((group) => {
  group.addEventListener("toggle", () => {
    if (!group.open) return;

    mobileShopGroups.forEach((otherGroup) => {
      if (otherGroup !== group) otherGroup.open = false;
    });
  });
});

document.addEventListener("click", (event) => {
  if (pinnedMenu && !header.contains(event.target)) closeMenu();
  if (searchOpen && !header.contains(event.target)) setSearch(false);
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && searchOpen) {
    setSearch(false);
    searchToggles[0]?.focus();
    return;
  }

  if (event.key === "Escape" && mobileMenuOpen) {
    setMobileMenu(false);
    mobileMenuToggle.focus();
    return;
  }

  if (event.key === "Escape" && openMenu) {
    const triggerToFocus = triggers.find(
      (trigger) => trigger.dataset.menuTrigger === openMenu,
    );
    closeMenu();
    triggerToFocus?.focus();
  }
});

// The cart is shared by every page that mounts this header. Loading it here
// keeps the page templates small while preserving a single reusable drawer.
async function mountCartDrawer() {
  if (
    document.querySelector("[data-cart-drawer]")
    || document.documentElement.dataset.cartDrawerMounting === "true"
  ) return;

  document.documentElement.dataset.cartDrawerMounting = "true";

  const headerScript = [...document.scripts].find((script) => script.src.includes("/header.js"));
  if (!headerScript) return;

  const componentUrl = new URL("../cart-drawer/index.html", headerScript.src);
  const stylesheetUrl = new URL("../cart-drawer/cart-drawer.css", headerScript.src);
  const scriptUrl = new URL("../cart-drawer/cart-drawer.js", headerScript.src);

  const ensureStylesheet = async () => {
    const existing = document.querySelector("link[data-cart-drawer-styles]");

    if (existing?.sheet) return;

    const stylesheet = existing || document.createElement("link");
    if (!existing) {
      stylesheet.rel = "stylesheet";
      stylesheet.href = stylesheetUrl.href;
      stylesheet.dataset.cartDrawerStyles = "true";
    }

    const loaded = new Promise((resolve, reject) => {
      stylesheet.addEventListener("load", resolve, { once: true });
      stylesheet.addEventListener("error", () => reject(new Error("Cart drawer stylesheet failed to load")), { once: true });
    });

    if (!existing) document.head.append(stylesheet);
    await loaded;
  };

  try {
    const [response] = await Promise.all([
      fetch(componentUrl.href),
      ensureStylesheet(),
    ]);
    if (!response.ok) throw new Error(`Cart drawer request failed: ${response.status}`);

    const componentDocument = new DOMParser().parseFromString(await response.text(), "text/html");
    const backdrop = componentDocument.querySelector("[data-cart-backdrop]");
    const drawer = componentDocument.querySelector("[data-cart-drawer]");
    if (!backdrop || !drawer) return;

    drawer.querySelectorAll("img[src]").forEach((image) => {
      image.src = new URL(image.getAttribute("src"), componentUrl.href).href;
    });

    document.body.append(backdrop, drawer);

    if (!document.querySelector("script[data-cart-drawer-script]")) {
      const script = document.createElement("script");
      script.src = scriptUrl.href;
      script.dataset.cartDrawerScript = "true";
      document.body.append(script);
    }
  } catch (error) {
    console.error(error);
  } finally {
    delete document.documentElement.dataset.cartDrawerMounting;
  }
}

mountCartDrawer();

function mountSiteExperience() {
  if (document.querySelector("script[data-site-experience-script]")) return;
  const headerScript = [...document.scripts].find((script) => script.src.includes("/header.js"));
  if (!headerScript) return;

  if (!document.querySelector("link[data-luxury-motion-styles]")) {
    const stylesheet = document.createElement("link");
    stylesheet.rel = "stylesheet";
    stylesheet.href = new URL("../../styles/luxury-motion.css", headerScript.src).href;
    stylesheet.dataset.luxuryMotionStyles = "true";
    document.head.append(stylesheet);
  }

  const experienceScript = document.createElement("script");
  experienceScript.src = new URL("../site-experience.js?v=20260806-1", headerScript.src).href;
  experienceScript.dataset.siteExperienceScript = "true";
  document.body.append(experienceScript);
}

/* mountAuthModal() removed here, and only here.

   The prototype mounted its own OTP dialog from ../auth-modal/. Per
   SHOPIFY_LIQUID_AUDIT 1.2 and answer B8, login is Shopify-hosted new customer
   accounts (passwordless email OTP + Google), so there is no theme-side auth
   modal to mount and the account links go straight to routes.account_url.
   Left in place it fetched a prototype-relative path that 404s on every page load.

   This is the only divergence from prototype/components/header/header.js.
   mountCartDrawer() is untouched: it early-returns because
   snippets/cart-drawer.liquid puts [data-cart-drawer] in the DOM server-side.
*/

mountSiteExperience();
